import React from 'react'
import { Link } from 'react-router'
import sortBy from 'lodash/sortBy'
import { prefixLink } from 'gatsby-helpers'
import { rhythm } from 'utils/typography'
import Helmet from 'react-helmet'
import { Container } from 'react-responsive-grid'
import access from 'safe-access'
import { config } from 'config'
import include from 'underscore.string/include'
import startsWith from 'underscore.string/startsWith'
import Masonry from 'react-masonry-component'
import BlogEntryCard from 'components/BlogEntryCard'

class BlogIndex extends React.Component {
  render () {

    const masonryOptions = {
      transitionDuration: 0,
      fitWidth: true,
      gutter: 30
    };

    const blogEntries = []
    // Sort pages.
    const sortedPages = sortBy(this.props.route.pages, (page) =>
      access(page, 'data.date')
    ).reverse()
    sortedPages.forEach((page) => {
      if (access(page, 'file.ext') === 'md' && 
          !include(page.path, '/404') && 
          startsWith(page.requirePath, 'blog/')) 
      {
        blogEntries.push(page);
        // const title = access(page, 'data.title') || page.path
        // pageLinks.push(
        //   <li
        //     key={page.path}
        //     style={{
        //       marginBottom: rhythm(1/4),
        //     }}
        //   >
        //     <Link style={{boxShadow: 'none'}} to={prefixLink(page.path)}>{title}</Link>
        //   </li>
        // )
      }
    })
    return (
      <div>
        <Helmet
          title={config.blogTitle}
          meta={[
            {"name": "description", "content": "Sample blog"},
            {"name": "keywords", "content": "blog, articles"},
          ]}
        />
        <Container
            className="page-container"
            style={{
              maxWidth: 1170,
              padding: `${rhythm(1)} ${rhythm(3/4)}`,
            }}
          >
          <div className="section-header">
            <h2>Blog</h2>
            <p>Some rants on Design, Technology, Philosophy and Caffeine.</p>
          </div>

          <Masonry
            className={'masonry-blog'} // default ''
            elementType={'ul'} // default 'div'
            options={masonryOptions} // default {}
            disableImagesLoaded={false} // default false
            updateOnEachImageLoad={false} // default false and works only if disableImagesLoaded is false
          >
            {blogEntries.map(p => (<BlogEntryCard page={p} />))}
          </Masonry>

        </Container>
      </div>
    )
  }
}

BlogIndex.propTypes = {
  route: React.PropTypes.object,
}

export default BlogIndex



/** WEBPACK FOOTER **
 ** ./blog-store/_legacyindex.js
 **/